import React, { useState } from "react";
import { Card, Col, Popconfirm, Row } from "antd";
import { Checkbox } from "antd";
import { message } from "antd";
import "../styles/layoutStyles.css";
import { useEffect } from "react";
import { Spin } from "antd";
import {
  REDIRECT_COACHING,
  REDIRECT_DELEGATE,
  REDIRECT_LEARNING,
} from "../../config";
import Axios from "../../api/Axios";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const MyApps = (props) => {
  // eslint-disable-next-line no-unused-vars
  //console.log(props);
  const [select, setSelect] = useState(true);

  const [newElements, setNewElements] = useState();
  const [loading, setLoading] = useState(true);
  const [userId, setUserId] = useState();
  const [messageApi, contextHolder] = message.useMessage();
  const csrfCookie = document.cookie
    .split("; ")
    .find((cookie) => cookie.startsWith("csrftoken="));
  const csrfToken = csrfCookie ? csrfCookie.split("=")[1] : null;
  // console.log(csrfToken);

  // let x = document.cookie;
  // console.log(x);
  const [appStates, setAppStates] = useState();
  const settingData = () => {
    setUserId(props.data.id);

    setNewElements(props.data.applications.map((application) => application));
    setAppStates((prevState) => {
      const updatedAppStates = {};

      props.data.applications?.forEach((app) => {
        updatedAppStates[app.name] =
          props.data?.default_application?.name === app.name;
      });

      return { ...prevState, ...updatedAppStates };
    });
    //console.log(appStates);
    setLoading(false);
  };
  useEffect(() => {
    settingData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  //console.log(appStates);
  const [appData, setAppData] = useState();
  const AppData = useSelector((state) => state?.user?.data?.applications);
  useEffect(() => {
    if (AppData) {
      const appDataObject = AppData.reduce((accumulator, app) => {
        accumulator[app.name] = app.id;
        return accumulator;
      }, {});
      setAppData(appDataObject);
    }
  }, [AppData]);

  // eslint-disable-next-line no-unused-vars
  const handleCheckboxClick = async (appName) => {
    //console.log(appData[appName]);
    try {
      const payload = {
        default_application: appStates[appName] ? null : appData[appName],
      };
      await Axios.put(`/user/${userId}/`, payload, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      //console.log(response);

      if (payload.default_application === null) {
        defaultRemoved();
      } else {
        defaultSet();
      }

      // return userData;
    } catch (error) {
      console.error(error);
    }
    setAppStates((prevState) => {
      // if the clicked checkbox is already checked, uncheck it
      if (prevState[appName]) {
        return { ...prevState, [appName]: false };
      }
      // if the clicked checkbox is not checked, check it and uncheck all other checkboxes
      const newState = {};
      for (let key in prevState) {
        newState[key] = key === appName;
      }
      return newState;
    });
  };
  const handleCheckboxClick2 = (appName) => {};
  const redirect = (index, name, url) => {
    //console.log(url);
    setSelect(true);
    if (name === "Trak Learning") {
      window.location.href = REDIRECT_LEARNING;
    } else if (name === "DelegateHR") {
      window.location.href = REDIRECT_DELEGATE;
    } else if (name === "Trak Coaching") {
      window.location.href = REDIRECT_COACHING;
    } else {
      window.location.href = url;
    }
  };

  const history = useNavigate();
  const redirectAdmin = () => {
    history("/admin-manager/clients");
  };

  const defaultSet = () => {
    messageApi.open({
      type: "success",
      content: "Default app set successfully",
      duration: 5,
    });
  };

  const defaultRemoved = () => {
    messageApi.open({
      type: "success",
      content: "Default app removed successfully",
      duration: 5,
    });
  };
  return (
    //<div style={{ width: "85%", margin: "0 auto" }}>
    <div style={{ width: "90%", margin: "0 auto" }}>
      {contextHolder}
      <Card
        bordered={false}
        style={{ borderRadius: 16, overflow: "hidden", marginTop: 10 }}
        title={
          <div className="moving-gradient-header">
            <span>MY APPLICATIONS</span>
          </div>
        }
        headStyle={{
          padding: 0,
          borderBottom: "none",
        }}
        bodyStyle={{
          padding: 24,
        }}
      >
        {loading ? (
          <Spin style={{ padding: "2rem" }} />
        ) : props.data.is_superadmin ? (
          <Row gutter={[18, 18]}>
            <Col xs={24} sm={12}>
              <div
                className={`logo-card-item available center-box ${
                  select ? "selected" : ""
                }`}
                onClick={redirectAdmin}
              >
                <span className="admin-text">ADMIN PAGE</span>
              </div>
            </Col>
          </Row>
        ) : (
          <Row gutter={[18, 18]}>
            {newElements?.map((value, index) => {
              const selected = appStates[value.name];
              return (
                <Col xs={24} sm={12} key={index}>
                  <div className="logo-wrapper">
                    <div
                      className={`logo-card-item available ${
                        select ? "selected" : ""
                      }`}
                      onClick={() => redirect(index, value.name, value.url)}
                    >
                      <div
                        className="checkbox-overlay"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <Popconfirm
                          title="Set as default?"
                          description="This will redirect to this application after login."
                          onConfirm={(e) => {
                            // Prevent redirection when confirming
                            e?.domEvent?.stopPropagation?.();
                            handleCheckboxClick2(value.name);
                          }}
                          okText="Yes"
                          cancelText="No"
                          placement="topRight"
                        >
                          <Checkbox
                            checked={selected}
                            onClick={(e) => e.stopPropagation()}
                          />
                        </Popconfirm>
                      </div>
                      <img
                        alt={value.name}
                        src={value.logo}
                        className="logo-image"
                      />
                    </div>
                  </div>
                </Col>
              );
            })}
          </Row>
        )}
      </Card>
    </div>
  );
};

export default MyApps;
